// Tiny success-tap haptic for the PWA. Android Chrome vibrates; iOS Safari
// has no navigator.vibrate, so this is a silent no-op there. Call ONLY on
// success paths of meaningful mutations (save, assign, toggle) — a buzz on
// every tap stops meaning anything.
export const buzz = (pattern = 12) => {
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) {
      navigator.vibrate(pattern);
    }
  } catch (_) {
    /* unsupported */
  }
};
